import React from 'react';

import RIQPageError from '../../../components/RIQPageError.jsx';
import ContactUsButton from './ContactUsButton.jsx';

export default function InvalidQuidMonitorTokenErrorPage({children}) {
    return (
        <RIQPageError>
            <p>
                Oops! Please contact us to verify your token settings are correct.
            </p>
            <p className='tlw-mt-15'>
                <ContactUsButton/>
            </p>
        </RIQPageError>
    );
}
